
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/account",
      function () {
        return require("private-next-pages/signup/account.tsx");
      }
    ]);
  